import { getOr } from 'lodash/fp';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectLocation = (state) => getOr(null, 'router.location.pathname', state);

export default selectLocation;
